import { ActionIcon, Tooltip } from "@mantine/core";
import { useTranslation } from "react-i18next";

import { SYSTEM_COLORS } from "@/configs/colorScheme";
import { useRoles } from "@/hooks/useRoles";
import Icon from "@/utils/icons";

export const AppAdmin = () => {
  const { t } = useTranslation();
  const { isGlobalAdmin, canEditCurrentWorkspace } = useRoles();

  if (isGlobalAdmin) {
    const color = canEditCurrentWorkspace ? SYSTEM_COLORS.success : SYSTEM_COLORS.error;
    const tooltipLabel = canEditCurrentWorkspace ? `${t("workspace")} (${t("admin")})` : t("admin");
    return (
      <Tooltip label={tooltipLabel}>
        <ActionIcon variant="transparent">
          <Icon.SETTINGS color={color} />
        </ActionIcon>
      </Tooltip>
    );
  }
  return null;
};

export default AppAdmin;
